import Stack from '@mui/material/Stack'

import { H3 } from '@mxenabled/mxui'

import SubHeader from './SubHeader'
import InsightOptionsMenu from './InsightOptionsMenu'
import { useBeatActions } from '../beatActions'
import type { Subtitle } from '../../core'

interface HeaderProps {
  isMini: boolean
  subtitle?: Subtitle
  title: string
}

const Header = ({ isMini, subtitle, title }: HeaderProps) => {
  // The overflow menu appears only when the host wired a menu handler and this
  // isn't the compact/mini layout. Handlers are delivered via context.
  const { onMenuAction } = useBeatActions()

  return (
    <Stack sx={{ gap: 4, pb: 12, pl: 16, pr: 16, pt: 16 }}>
      <Stack sx={{ alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between' }}>
        <H3>{title}</H3>
        {!isMini && onMenuAction && <InsightOptionsMenu />}
      </Stack>

      {/* Sub Header */}
      {subtitle && <SubHeader subtitle={subtitle} />}
    </Stack>
  )
}

export default Header
